const nonce = Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);
export default nonce;
//# sourceMappingURL=nonce.js.map